import { useSelector } from "react-redux";
import Sidebar from "../../../components/Sidebar";
import PlansContainer from "../../../components/Plans/PlansContainer";

export default function Plans() {
    const userPlanDetails = useSelector(
        (state) => state?.userPlan?.userPlanDetails?.[0]
    );
    const userData = useSelector((state) => state?.user?.userData);
    return (
        <>
            <div
                id="main-container"
                className="container-fluid main"
                style={{ overflowY: "scroll", height: "100vh" }}
            >
                {/* {userData &&
                    window.location.pathname !== "/" &&
                    userPlanDetails && ( */}
                <div class="left-main-menu">
                    <Sidebar />
                </div>
                {/* )} */}
                <div className="container">
                    <section className="sub_sec sub_sec_cms" id="sub_sec">
                        <img
                            src="/assets/images/ringcms.svg"
                            className="ring_img_cms"
                            alt=""
                        />
                        <div className="container container_sub">
                            <PlansContainer />
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}
